<template>
  <div>
    <!-- <PageLoader /> -->
    <div>
      <EcpSign :xmlToSignPro="tmzReport.xmlToSign" :tmzId="tmzReport.id" />
      <StepHeader :tmzId="this.$route.params.id" />
    </div>
    <div class="table-container-inner">
      <table>
        <thead>
          <tr>
            <th>Наименование</th>
            <th>№ п/п</th>
            <th>Ед. изм.</th>
            <th>Кол-во</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="firstRow"
            v-for="data in data_liquid_demand"
            :key="data.id"
          >
            <td class="firstNaming">Остатки востребованных ТМЗ</td>
            <td class="seqNumber firstTarget">1</td>
            <td>{{ data.key }}</td>
            <td>{{ data.value }}</td>
          </tr>
          <tr v-for="data in data_liquid_unclaimed" :key="data.key">
            <td class="secondNaming">Остатки невостребованных ТМЗ</td>
            <td class="seqNumber secondTarget">2</td>
            <td>{{ data.key }}</td>
            <td>{{ data.value }}</td>
          </tr>
          <tr v-for="data in data_illiquid" :key="data.key">
            <td class="thirdNaming">Остатки неликвидных ТМЗ</td>
            <td class="seqNumber thirdTarget">3</td>
            <td>{{ data.key }}</td>
            <td>{{ data.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import StepHeader from "@/components/tmz/StepHeader";
import PageLoader from "@/components/PageLoader";
import EcpSign from "@/components/tmz/EcpSign";
import { mapGetters } from 'vuex';

export default {
  name: "FormSix",
  data() {
    return {
      formSixData: {},
      data_liquid_demand: {},
      data_liquid_unclaimed: {},
      data_illiquid: {},
      tmzReport: {},
    };
  },
  components: {
    StepHeader,
    PageLoader,
    EcpSign
  },
  methods: {
    getTmzFormSix() {
      this.$store
        .dispatch("getTmzFormSix", this.$route.params.id)
        .then((response) => {
          this.data_liquid_demand = Object.entries(
            response.data_liquid_demand
          ).map(([key, value]) => ({ key, value }));
          this.data_liquid_unclaimed = Object.entries(
            response.data_liquid_unclaimed
          ).map(([key, value]) => ({ key, value }));
          this.data_illiquid = Object.entries(
            response.data_illiquid
          ).map(([key, value]) => ({ key, value }));
        });
    },
    rebuildTable() {
      let firstTarget = document.querySelector(".firstTarget");
      let firstNamings = document.querySelectorAll(".firstNaming");
      let newTd1 = document.createElement("td");
      let secondTarget = document.querySelector(".secondTarget");
      let secondNamings = document.querySelectorAll(".secondNaming");
      let newTd2 = document.createElement("td");
      let thirdTarget = document.querySelector(".thirdTarget");
      let thirdNamings = document.querySelectorAll(".thirdNaming");

      let newTd3 = document.createElement("td");

      firstNamings.forEach((element) => {
        element.remove();
      });

      newTd1.style.borderBottom = "1px solid #333";
      newTd1.style.borderLeft = "1px solid #333";
      newTd1.innerHTML = "Остатки востребованных ТМЗ";
      newTd1.setAttribute("rowspan", this.data_liquid_demand.length);
      firstTarget.parentNode.insertBefore(newTd1, firstTarget);

      secondNamings.forEach((element) => {
        element.remove();
      });

      newTd2.style.borderBottom = "1px solid #333";
      newTd2.style.borderLeft = "1px solid #333";
      newTd2.innerHTML = "Остатки невостребованных ТМЗ";
      newTd2.setAttribute("rowspan", this.data_liquid_unclaimed.length);
      secondTarget.parentNode.insertBefore(newTd2, secondTarget);

      thirdNamings.forEach((element) => {
        element.remove();
      });

      // newTd3.style.borderBottom = '1px solid #333';
      newTd3.style.borderLeft = "1px solid #333";
      newTd3.innerHTML = "Остатки неликвидных ТМЗ";
      newTd3.setAttribute("rowspan", this.data_illiquid.length);
      thirdTarget.parentNode.insertBefore(newTd3, thirdTarget);

      let seqNums = document.querySelectorAll(".seqNumber");

      for (let i = 0; i < seqNums.length; i++) {
        seqNums[i].innerHTML = i + 1;
      }
    },
    getTmzReport() {
      this.$store.dispatch("getTmzReport", this.$route.params.id).then((response) => {
        this.tmzReport = response;
        this.getLiquidDemandReportRequest(this.tmzReport.liquidDemand)
        this.getLiquidDemandReport(this.tmzReport.liquidDemand);
      });
    },
  },
  computed: {
    ...mapGetters(["TMZREPORT"])
  },
  created() {
    this.getTmzFormSix();
  },
  updated() {
    this.$nextTick(function () {
      this.rebuildTable();
    });
  },
};
</script>

<style scoped>
.bottomBorder {
  border-bottom: 1px solid #333;
}
.table-container {
  /* overflow-x: auto; */
  margin: 2rem;
  min-width: 1800px;
  /* margin: 0 auto; */
  overflow: auto;
}

.table-container-inner {
  padding: 0.5rem;
  margin: 0 2rem;
  /* padding: 1rem 2rem; */
  /* margin-right: 2rem; */
  /* margin: 1rem 2rem; */
  overflow-x: auto;
  max-width: 100vw;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin: 0 auto 2rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
  font-size: 14px;
}

.table-naming {
  font-size: 2rem;
  font-weight: bold;
  padding: 1rem 0;
  text-align: left;
}

.table-status {
  margin-bottom: 0.5rem;
}

th,
td {
  border: 1px solid #868686;
  padding: 0 1rem;
}

.expanded {
  padding: 0 2rem;
}

.table-specs {
  background: #36429e;
  width: 100px;
  height: 100px;
  color: white;
  text-align: center;
  border-top-left-radius: 10px;
  border: none;
  font-size: 1.5rem;
  vertical-align: bottom;
}

.table-actions {
  display: flex;
  padding: 2rem 0;
  justify-content: center;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
  margin: 0 auto;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.btn-yellow {
  background: #ffbb56;
  color: white;
}

.btn-red {
  background: #e86363;
  color: white;
}

.btn-blue {
  background: #6c63e8;
  color: white;
}

.btn-upload-file {
  background: none;
  margin-left: -1rem;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.btn-blue {
  background: #36429e;
  color: white;
}

.file-area {
  width: 100%;
  position: relative;
}

.file-area input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
  border-radius: 25px;
}

.file-area .file-state {
  width: 100%;
  padding: 1rem 1rem;

  border-radius: 10px;
  /* margin-left: 1rem; */
  cursor: pointer;
  font-size: 1.1rem;

  background: #5769f8;
  color: #fff;
  text-align: center;
  transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
  display: none;
}

.file-area:hover .file-state {
  background: rgba(255, 255, 255, 0.1);
  color: black !important;
}

/* *[data-tooltip] {
  position: relative;
}

*[data-tooltip]::after {
  content: attr(data-tooltip);

  position: absolute;
  top: 50px;
  right: -50px;
  width: 150px;

  pointer-events: none;
  opacity: 0;
  -webkit-transition: opacity 0.15s ease-in-out;
  -moz-transition: opacity 0.15s ease-in-out;
  -ms-transition: opacity 0.15s ease-in-out;
  -o-transition: opacity 0.15s ease-in-out;
  transition: opacity 0.15s ease-in-out;

  display: block;
  font-size: 12px;
  line-height: 16px;
  background: #fefdcd;
  padding: 2px 2px;
  border: 1px solid #c0c0c0;
  box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.4);
}

*[data-tooltip]:hover::after {
  opacity: 1;
} */

.table-filter-container {
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.table-filter-select {
  max-width: 400px;
}

.table-filter-submit {
  /* width: 200px; */
  /* height: 60px; */
  padding: 0.5rem 1rem;
  background: #36429e;
  color: #fff;
  border: none;
  outline: none;
  border-radius: 10px;
  font-size: 1.2rem;
  cursor: pointer;
}

.filter-search-input {
  padding: 1rem 2rem;
  border-radius: 10px;
  border: 1px solid black;
}
</style>